"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("./theme"));
var DEFAULT_SIZE = "middle";
var colorSchema = {
    primary: {
        color: theme_1.default.colors.white,
        border: theme_1.default.colors.darkGray,
        background: theme_1.default.colors.darkGray,
        hover: {
            border: theme_1.default.colors.black,
            background: theme_1.default.colors.black,
        },
    },
    secondary: {
        color: theme_1.default.colors.gray,
        border: theme_1.default.colors.gray,
        background: theme_1.default.colors.white,
        hover: {
            border: theme_1.default.colors.gray,
            background: theme_1.default.colors.whiteGray,
        },
    },
    disabled: {
        color: theme_1.default.colors.white,
        border: theme_1.default.colors.whiteGray,
        background: theme_1.default.colors.whiteGray,
    },
};
var extractEvents = function (props) {
    var rest = {};
    var events = {};
    for (var prop in props) {
        if (typeof props[prop] === "function" &&
            prop.length > 2 &&
            prop.startsWith("on") &&
            prop[2].toUpperCase() === prop[2]) {
            events[prop] = props[prop];
        }
        else {
            rest[prop] = props[prop];
        }
    }
    return { events: events, rest: rest };
};
var Button = function (props) {
    var _a = extractEvents(props), events = _a.events, nonEvents = _a.rest;
    var children = nonEvents.children, rest = __rest(nonEvents, ["children"]);
    var schema = colorSchema[props.disabled ? "disabled" : props.color || "primary"];
    return (react_1.default.createElement(StyledButton, __assign({}, events, rest, { schema: schema }),
        props.icon ? (react_1.default.createElement(StyledIcon, __assign({}, rest, { schema: schema }), props.icon)) : null,
        react_1.default.createElement(StyledText, __assign({}, rest, { schema: schema }), children)));
};
var StyledIcon = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin-right: 7px;\n  > svg {\n    vertical-align: top;\n  }\n"], ["\n  color: ", ";\n  margin-right: 7px;\n  > svg {\n    vertical-align: top;\n  }\n"])), function (props) { return props.schema.color; });
var StyledText = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var StyledButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n  border: ", "\n    ", " solid;\n  display: inline-block;\n\n  height: ", ";\n  border-radius: 40px;\n  padding: 0 ", ";\n\n  color: ", ";\n  font-weight: 700;\n  font-size: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n    border: ", "\n      ", " solid;\n  }\n\n  &:disabled {\n    cursor: inherit;\n    opacity: 0.3;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  background: ", ";\n  border: ", "\n    ", " solid;\n  display: inline-block;\n\n  height: ", ";\n  border-radius: 40px;\n  padding: 0 ", ";\n\n  color: ", ";\n  font-weight: 700;\n  font-size: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n    border: ", "\n      ", " solid;\n  }\n\n  &:disabled {\n    cursor: inherit;\n    opacity: 0.3;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n"])), function (props) { return props.schema.background; }, function (props) { return props.schema.border; }, function (props) { return ({ tiny: "0px", small: "1px", middle: "2px" }[props.size || DEFAULT_SIZE]); }, function (props) { return ({ tiny: "16px", small: "24px", middle: "32px" }[props.size || DEFAULT_SIZE]); }, function (props) { return ({ tiny: "4px", small: "8px", middle: "16px" }[props.size || DEFAULT_SIZE]); }, function (props) { return props.schema.color; }, function (props) { return ({ tiny: "8px", small: "13px", middle: "15px" }[props.size || DEFAULT_SIZE]); }, function (props) { var _a; return (_a = props.schema.hover) === null || _a === void 0 ? void 0 : _a.background; }, function (props) { var _a; return (_a = props.schema.hover) === null || _a === void 0 ? void 0 : _a.border; }, function (props) { return ({ tiny: "0px", small: "1px", middle: "2px" }[props.size || DEFAULT_SIZE]); });
Button.defaultProps = {
    size: "middle",
    color: "primary",
};
exports.default = Button;
var templateObject_1, templateObject_2, templateObject_3;
